export default {
    listagem: {
        titulo_pagina: 'Lista de Formatos de Archivo',
        novo: 'Agregar Nuevo Formato de Archivo',
        table: {
            empty: 'No se encontró formato',
            nome: 'Nombre',
            classe: 'Clase',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Formato',
            editar: 'Formato de Edición'
        },
        fields: {
            nome: {
                label: 'Nombre',
                description: 'Nombre del formato'
            },
            classe: {
                label: 'Clase',
                description: 'Clase que ejecuta el formato'
            },
            extensao: {
                label: 'Extensión',
                description: 'Extensión de archivo generada por analizador'
            },
            has_cloud_function: {
                label: 'Cloud Function',
                description: 'El formato de archivo tiene Cloud Function de conversión'
            },
            cloud_function: {
                label: 'Nombre Cloud Function',
                description: 'Cloud Function que realiza la conversión',
                selecionar: 'Seleccionar...'
            },
            status: {
                label: 'Estado',
                description: 'Formato de estado activo o inactivo'
            },
            botao_salvar : 'Guardar Formato'
        },
        create: {
            success: '¡Formato creado con éxito!',
            error: '¡Error al crear el formato!'
        },
        update: {
            success: '¡Formato editado con éxito!',
            error: '¡Error al editar el formato!'
        }
    }
}
